module.exports = __webpack_public_path__ + "static/media/dark-tick.27e2998f.svg";